import { Popover, PopoverProps } from 'antd'
import React from 'react'

const CommonPopover = ({
  children,
  content,
  overlayInnerStyle = {},
  ...props
}: PopoverProps) => {
  return (
    <Popover
      trigger="hover"
      transitionName=""
      overlayInnerStyle={{
        background:
          'linear-gradient( 180deg, #180E1F 0%, #41234D 50%, #1D1515 100%)',
        backgroundColor: 'rgba(0,0,0,0.3)',
        border: '1px solid rgba(255,255,255,0.2)',
        padding: '0',
        borderRadius: '10px',
        opacity: '0.9',
        ...overlayInnerStyle,
      }}
      placement="bottomRight"
      content={content}
      arrow={false}
      className="max-md:hidden"
      {...props}
    >
      {children}
    </Popover>
  )
}

export default CommonPopover
